module.exports = __webpack_public_path__ + "img/931.92e2153b.jpg";